// @flow

import React, { type Node, useEffect } from 'react';
import { type AnalyticsEventType } from './types';
import { useAnalyticsContext } from './context';
import { Empty } from '@tectonics/components';

type Props = {|
  eventType: AnalyticsEventType,
|};

export function CachedEvent({ eventType }: Props): Node {
  const analytics = useAnalyticsContext();

  useEffect(() => {
    analytics.event(eventType);
  }, [eventType, analytics]);

  return <Empty />;
}
